import { RequestStatusWithData } from '@customTypes/api/api.types';

export enum REQUEST_PATH {
    LOCATE_PRODUCT = '/ManageInventory/LocateProduct',
    PARTS = '/ManageInventory/Parts'
}

export interface LocateProductlDTO {
    AccountNum: string;
    SubAccountNum: string;
    ClientItemIds: string[];
    Ssls: string[];
}

interface LocateProductResponseData {
    ssls: LocateProductWarehouse[];
}

interface LocateProductWarehouse {
    code: string;
    city?: string;
    country?: string;
    countryCode?: string;
    province?: string;
    parts: LocateProductPart[];
}

export interface LocateProductPart {
    clientItemId: string;
    productDescription?: string;
    goodAvailableQty: number;
    goodCommittedQty: number;
    badAvailableQty: number;
    badCommittedQty: number;
    serialList: LocateProductSerial[];
    substituteItemList: LocateProductSubstituteItem[];
}

export interface LocateProductSerial {
    condition: string;
    isCommitted: boolean;
    clientSerial: string;
    countryOfManufacture?: string;
    revisionLevel?: string;
    refurbished: boolean;
}

interface LocateProductSubstituteItem {
    clientSubstituteItemId: string;
}

export type LocateProductResponse =
    RequestStatusWithData<LocateProductResponseData>;
